import { useState, useEffect, useCallback } from 'react';

/**
 * Tracks OneTrust consent for a cookie group, defaulting to C0003
 * (Functional Cookies), which is what gates video embeds.
 *
 * OneTrust exposes the accepted groups as a string like ",C0001,C0003," and
 * fires an event whenever the visitor changes their preferences.
 */
const useCookieConsent = (group = 'C0003') => {
  const checkConsent = useCallback(() => {
    if (typeof window === 'undefined') return false;
    const groups = window.OnetrustActiveGroups || window.OptanonActiveGroups || '';
    return groups.indexOf(group) !== -1;
  }, [group]);

  const [hasConsent, setHasConsent] = useState(checkConsent);

  useEffect(() => {
    const onConsentChange = () => setHasConsent(checkConsent());

    window.addEventListener('OneTrustGroupsUpdated', onConsentChange);
    window.addEventListener('consent.onetrust', onConsentChange);
    // Re-check on mount in case consent was granted before this ran
    onConsentChange();

    return () => {
      window.removeEventListener('OneTrustGroupsUpdated', onConsentChange);
      window.removeEventListener('consent.onetrust', onConsentChange);
    };
  }, [checkConsent]);

  return hasConsent;
};

export default useCookieConsent;
